export default __webpack_public_path__ + "static/media/icon__menu.4d1e0525.svg";